export enum MonetizationTab {
    LensPlus = "lens-plus",
    TopPerformer = "top-performer",
}

export const DEFAULT_MONETIZATION_TAB = MonetizationTab.LensPlus;

const tabSet = new Set<string>(Object.values(MonetizationTab));

export const isMonetizationTab = (value?: string | null): value is MonetizationTab => !!value && tabSet.has(value);
